module.exports = "<span class=\"gw-accordion-chevron gw-accordion-chevron_flavor_{{ _flavor }}\"\r\n      ng-class=\"{\r\n            'gw-accordion-chevron_open': isOpen,\r\n            'fa fa-chevron-down': _flavor === 'default',\r\n            'fa fa-info-circle': _flavor === 'infocircle',\r\n            'fa fa-angle-down': _flavor === 'angledown'\r\n      }\"></span>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/accordion/directives/templates/accordion-chevron.html
// module id = 560
// module chunks = 0